<div class="h-[calc(100vh-68px)] flex justify-center items-center">
  @if (token$ | async) {
    <app-user-register-form></app-user-register-form>
  } @else {
    <app-user-verify-email-form></app-user-verify-email-form>
  }
</div>
